import { render, staticRenderFns } from "./sign-out.vue?vue&type=template&id=316b07da&"
import script from "./sign-out.vue?vue&type=script&lang=js&"
export * from "./sign-out.vue?vue&type=script&lang=js&"
import style0 from "./sign-out.vue?vue&type=style&index=0&id=316b07da&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports